import React, { useContext } from 'react'

import { DataContext } from '../../DataContext'
import Assignment from './Assignment'
import FacilityAssignmentContextProvider from './DataContext'
import PanelStyleContextProvider from '../../../../elem/panel/PanelStyleContext'
import FacilityFilter from './FacilityFilter'

import Panel from '../../../../elem/panel/Panel'
import { wellPanel } from '../../../../../utils/styles/panelStyles'

const FacilityAssignment = () => {
    const { activePanel, viewOnly } = useContext(DataContext)
    return (
        <div
            className={`columns is-multiline
                ${activePanel !== 'Filter Wells' ? 'is-hidden' : ''}
            `}
        >
            <FacilityAssignmentContextProvider>
                <PanelStyleContextProvider panelClassConfig={{}}>
                    {!viewOnly && <FacilityFilter />}
                </PanelStyleContextProvider>
                <div className="column is-12 assignmentPanel">
                    <Panel panelClassConfig={wellPanel('full')}>
                        <Assignment />
                    </Panel>
                </div>
            </FacilityAssignmentContextProvider>
        </div>
    )
}

export default FacilityAssignment
